document.documentElement.classList.remove('no-js');

const heroCarouselTimers = new WeakMap();

function setHeroSlide(carousel, requestedIndex) {
  const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
  if (slides.length < 2) return;
  const index = (requestedIndex + slides.length) % slides.length;

  slides.forEach((slide, slideIndex) => {
    const active = slideIndex === index;
    slide.classList.toggle('is-active', active);
    slide.setAttribute('aria-hidden', active ? 'false' : 'true');
  });
  carousel.querySelectorAll('[data-hero-dot]').forEach((dot) => {
    const active = Number(dot.dataset.heroDot) === index;
    dot.classList.toggle('is-active', active);
    dot.setAttribute('aria-current', active ? 'true' : 'false');
  });
  carousel.dataset.activeIndex = String(index);
  const image = slides[index].querySelector('img');
  if (image?.loading === 'lazy') image.loading = 'eager';
}

function stopHeroCarousel(carousel) {
  const timer = heroCarouselTimers.get(carousel);
  if (timer) window.clearInterval(timer);
  heroCarouselTimers.delete(carousel);
}

function startHeroCarousel(carousel) {
  if (heroCarouselTimers.has(carousel) || carousel.dataset.manuallyChanged === 'true' || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const timer = window.setInterval(() => {
    setHeroSlide(carousel, Number(carousel.dataset.activeIndex || 0) + 1);
  }, 6500);
  heroCarouselTimers.set(carousel, timer);
}

document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-hero-previous], [data-hero-next], [data-hero-dot]');
  if (!control) return;
  const carousel = control.closest('[data-hero-carousel]');
  if (!carousel) return;
  carousel.dataset.manuallyChanged = 'true';
  stopHeroCarousel(carousel);
  const index = Number(carousel.dataset.activeIndex || 0);
  if (control.hasAttribute('data-hero-previous')) setHeroSlide(carousel, index - 1);
  else if (control.hasAttribute('data-hero-next')) setHeroSlide(carousel, index + 1);
  else setHeroSlide(carousel, Number(control.dataset.heroDot));
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  if (carousel.querySelectorAll('[data-hero-slide]').length < 2) return;
  carousel.addEventListener('mouseenter', () => stopHeroCarousel(carousel));
  carousel.addEventListener('mouseleave', () => startHeroCarousel(carousel));
  carousel.addEventListener('focusin', () => stopHeroCarousel(carousel));
  carousel.addEventListener('focusout', () => {
    window.setTimeout(() => {
      if (!carousel.contains(document.activeElement)) startHeroCarousel(carousel);
    }, 0);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopHeroCarousel(carousel);
    else startHeroCarousel(carousel);
  });
  startHeroCarousel(carousel);
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drawer-close]');
  if (!trigger) return;
  const drawer = trigger.closest('details');
  if (drawer) drawer.removeAttribute('open');
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const form = selector.closest('form');
  const button = form?.querySelector('[data-add-to-cart]');
  const option = selector.options[selector.selectedIndex];
  if (!button || !option) return;
  button.disabled = option.dataset.available !== 'true';
  button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldOutText;
});

function carouselIndexes(carousel) {
  return [...carousel.querySelectorAll('[data-carousel-slide]')]
    .map((slide, index) => slide.hidden ? null : index)
    .filter((index) => index !== null);
}

function filterCarouselByVariant(carousel, variantButton) {
  if (carousel.dataset.filterByColor !== 'true' || !variantButton) return;
  const colors = [...variantButton.closest('form').querySelectorAll('[data-variant-button]')]
    .map((button) => button.dataset.variantTitle.toLowerCase());
  const selectedColor = variantButton.dataset.variantTitle.toLowerCase();
  const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
  const matches = slides.map((slide) => {
    const alt = (slide.querySelector('img')?.alt || '').toLowerCase();
    const imageColors = colors.filter((color) => alt.includes(color));
    return imageColors.length === 1 && imageColors[0] === selectedColor;
  });
  const hasMatches = matches.some(Boolean);
  slides.forEach((slide, index) => { slide.hidden = hasMatches && !matches[index]; });
  carousel.querySelectorAll('[data-carousel-thumbnail], [data-carousel-dot]').forEach((control) => {
    const index = Number(control.dataset.carouselThumbnail ?? control.dataset.carouselDot);
    control.hidden = hasMatches && !matches[index];
  });
  carousel.querySelectorAll('[data-carousel-previous], [data-carousel-next]').forEach((control) => {
    control.hidden = carouselIndexes(carousel).length < 2;
  });
}

function stepCarouselSlide(carousel, direction) {
  const indexes = carouselIndexes(carousel);
  if (!indexes.length) return;
  const current = indexes.indexOf(Number(carousel.dataset.activeIndex || 0));
  const next = (Math.max(current, 0) + direction + indexes.length) % indexes.length;
  setCarouselSlide(carousel, indexes[next]);
}

function setCarouselSlide(carousel, requestedIndex) {
  const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
  const indexes = carouselIndexes(carousel);
  if (!indexes.length) return;

  const index = indexes.includes(requestedIndex) ? requestedIndex : indexes[0];
  const thumbnails = [...carousel.querySelectorAll('[data-carousel-thumbnail]')];
  const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];

  slides.forEach((slide, slideIndex) => {
    const active = slideIndex === index;
    slide.classList.toggle('is-active', active);
    slide.setAttribute('aria-hidden', active ? 'false' : 'true');
  });

  [...thumbnails, ...dots].forEach((control) => {
    const controlIndex = Number(control.dataset.carouselThumbnail ?? control.dataset.carouselDot);
    const active = controlIndex === index;
    control.classList.toggle('is-active', active);
    control.setAttribute('aria-current', active ? 'true' : 'false');
  });

  const counter = carousel.querySelector('[data-carousel-current]');
  if (counter) counter.textContent = String(indexes.indexOf(index) + 1);
  carousel.dataset.activeIndex = String(index);

  const activeThumbnail = thumbnails[index];
  if (carousel.dataset.ready === 'true') {
    activeThumbnail?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}

function selectProductVariant(variantButton) {
  if (!variantButton || variantButton.disabled) return;
  const form = variantButton.closest('form');
  const productInfo = variantButton.closest('.product-info');
  const variantInput = form?.querySelector('[data-variant-input]');
  const addButton = form?.querySelector('[data-add-to-cart]');
  const price = productInfo?.querySelector('[data-product-price]');
  const comparePrice = productInfo?.querySelector('[data-product-compare-price]');
  const discount = productInfo?.querySelector('[data-product-discount]');
  const title = productInfo?.querySelector('[data-selected-variant]');
  const productSection = variantButton.closest('.main-product');
  const carousel = productSection?.querySelector('[data-product-carousel]');
  const available = variantButton.dataset.available === 'true';

  form?.querySelectorAll('[data-variant-button]').forEach((button) => {
    const selected = button === variantButton;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  if (variantInput) variantInput.value = variantButton.dataset.variantId;
  if (price) price.textContent = variantButton.dataset.variantPrice;
  const comparePriceText = variantButton.dataset.variantComparePrice || '';
  const discountText = variantButton.dataset.variantDiscount || '';
  if (comparePrice) {
    comparePrice.textContent = comparePriceText;
    comparePrice.classList.toggle('is-hidden', !comparePriceText);
  }
  if (discount) {
    discount.textContent = discountText;
    discount.classList.toggle('is-hidden', !discountText);
  }
  if (title) title.textContent = variantButton.dataset.variantTitle;
  if (carousel) {
    filterCarouselByVariant(carousel, variantButton);
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const imageIndex = slides.findIndex((slide) => slide.dataset.imageId === variantButton.dataset.variantImageId);
    setCarouselSlide(carousel, imageIndex);
  }
  if (addButton) {
    addButton.disabled = !available;
    addButton.textContent = available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
  }
}

document.addEventListener('click', (event) => {
  const carousel = event.target.closest('[data-product-carousel]');
  if (carousel) {
    if (event.target.closest('[data-carousel-previous]')) stepCarouselSlide(carousel, -1);
    if (event.target.closest('[data-carousel-next]')) stepCarouselSlide(carousel, 1);

    const thumbnail = event.target.closest('[data-carousel-thumbnail]');
    if (thumbnail) setCarouselSlide(carousel, Number(thumbnail.dataset.carouselThumbnail));

    const dot = event.target.closest('[data-carousel-dot]');
    if (dot) setCarouselSlide(carousel, Number(dot.dataset.carouselDot));
  }

  const variantButton = event.target.closest('[data-variant-button]');
  if (variantButton && !variantButton.disabled) {
    const url = new URL(window.location.href);
    const currentId = variantButton.closest('form')?.querySelector('[data-variant-input]')?.value;
    if (!url.searchParams.has('variant') && currentId) {
      url.searchParams.set('variant', currentId);
      window.history.replaceState(window.history.state, '', url.toString());
    }
    if (url.searchParams.get('variant') !== variantButton.dataset.variantId) {
      url.searchParams.set('variant', variantButton.dataset.variantId);
      window.history.pushState(window.history.state, '', url.toString());
    }
    selectProductVariant(variantButton);
  }

  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.closest('.quantity-stepper')?.querySelector('[data-quantity-input]');
    if (!input) return;
    const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
    input.value = String(nextValue);
  }
});

document.addEventListener('touchstart', (event) => {
  const stage = event.target.closest('[data-carousel-stage]');
  if (!stage) return;
  stage.dataset.touchStartX = String(event.changedTouches[0].clientX);
}, { passive: true });

document.addEventListener('touchend', (event) => {
  const stage = event.target.closest('[data-carousel-stage]');
  const carousel = stage?.closest('[data-product-carousel]');
  if (!stage || !carousel || !stage.dataset.touchStartX) return;

  const distance = event.changedTouches[0].clientX - Number(stage.dataset.touchStartX);
  if (Math.abs(distance) < 45) return;
  stepCarouselSlide(carousel, distance < 0 ? 1 : -1);
}, { passive: true });

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const selectedButton = carousel.closest('.main-product')?.querySelector('[data-variant-button].is-selected');
  filterCarouselByVariant(carousel, selectedButton);
  const activeSlide = carousel.querySelector('[data-carousel-slide].is-active');
  setCarouselSlide(carousel, Number(activeSlide?.dataset.slideIndex || 0));
  carousel.dataset.ready = 'true';
});


document.addEventListener('change', (event) => {
  const sort = event.target.closest('[data-collection-sort]');
  if (!sort) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  url.searchParams.set('sort_by', sort.value);
  window.location.assign(url.toString());
});


window.addEventListener('popstate', () => {
  const variantId = new URL(window.location.href).searchParams.get('variant');
  const variantButton = [...document.querySelectorAll('.main-product [data-variant-button]')].find((button) => button.dataset.variantId === variantId);
  selectProductVariant(variantButton);
});

